import ReactDOM from "react-dom/client";

import { initDatadogRum } from "@libs/datadog/initDatadogRum";
import { initSentry } from "@libs/sentry/initSentry";

import App from "./App";
import reportWebVitals from "./reportWebVitals";

initSentry();
initDatadogRum();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(<App />);

reportWebVitals();
